const keyCodes = {
    ENTER: 13,
    SPACE: 32,
    DOWN_ARROW: 40,
    ESC: 27,
    UP_ARROW: 38
};
export default Object.freeze(keyCodes);
